import { Car, Filter, Calendar, Search } from "lucide-react";
import SelectField from "../common/SelectField";
import SearchBar from "../common/SearchBar";

export default function OrderHeader({
  total,
  search,
  onSearch,
  statusFilter,
  onStatusChange,
  dateFilter,
  onDateChange,
}) {
  return (
    <div className="pageHeader">
      <div className="headerTop">
        <div className="pageTitle">
          <div className="titleWithIcon">
            <Car size={24} className="primaryIcon" />
            <h2>Commandes</h2>
          </div>
          <span className="countBadge">{total} commandes</span>
        </div>
      </div>

      <div className="filterActionsRow">
        <div className="selectorsGrid">
          <SelectField
            icon={Filter}
            value={statusFilter}
            onChange={onStatusChange}
            options={[
              { label: "Tous les statuts", value: "all" },
              { label: "En attente", value: "En attente" },
              { label: "En cours", value: "En cours" },
              { label: "Terminé", value: "Terminé" },
              { label: "Annulé", value: "Annulé" },
            ]}
          />
          <SelectField
            icon={Calendar}
            value={dateFilter}
            onChange={onDateChange}
            options={[
              { label: "Toutes les dates", value: "all" },
              { label: "Aujourd'hui", value: "today" },
              { label: "Hier", value: "yesterday" },
              { label: "Cette semaine", value: "week" },
              { label: "Ce mois-ci", value: "month" },
            ]}
          />
        </div>

        <div className="searchWrapper">
          <SearchBar
            value={search}
            onChange={onSearch}
            placeholder="Rechercher client, chauffeur..."
          />
        </div>
      </div>
    </div>
  );
}
